module.exports = __webpack_public_path__ + "img/winner-icon.a00bf4ea.svg";